export default theme => ({
  subtitle: {
    marginBottom: "20px",
    marginTop: "20px",
  },
  selectAll: {
    display: "inline-block",
  },
});
